export type UrnType = 'section' | 'interview' | 'question' | 'text';

const shortUrnToUrn = (uniquePart: string, type: UrnType): string => {
  if (type === 'interview') {
    return `urn:pg:interview:${uniquePart}`;
  }

  return `urn:pg:interview:${type}:${uniquePart}`;
};

export default shortUrnToUrn;
